<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="用户ID" class="tiny">
						<el-input style="width: 200px" v-model="searchInfo.userId" placeholder="请输入用户ID"></el-input>
					</el-form-item>
					<el-form-item label="账号" class="tiny">
						<el-input style="width: 200px" v-model="searchInfo.username" placeholder="请输入用户账号"></el-input>
					</el-form-item>
					<el-form-item label="手机号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.phone" placeholder="请输入用户手机号"></el-input>
					</el-form-item>
					<!-- <el-form-item label="时间">
                        <div class="block">iphone
                            <el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss"
                                type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
                                :default-time="['00:00:00', '23:59:59']">
                            </el-date-picker>
                        </div>
                    </el-form-item> -->
					<el-form-item label="钱包地址" class='tiny'>
                        <el-input style="width: 200px;" v-model="searchInfo.withdrawalAddress" placeholder="请输入钱包地址"></el-input>
                    </el-form-item>

					<el-form-item label="资产名称" class='tiny'>
						<el-select v-model="searchInfo.integralId" class="big" placeholder="请选择" clear>
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option v-for="item in integralList" :key="item.id" :value="item.id" :label="item.name">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<el-button type="primary" @click="downloadFile"> 导出 </el-button>
							<!-- <el-button type="primary" @click="downloadExamineD"> 复核 </el-button> -->
							<!-- <el-button type="primary" @click="editialogVisible()">新增用户
                            </el-button> -->
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<div style="margin: 20px">
			<div style="font-size: 14px;display: flex;justify-content: start;align-items: center;">
				<div><span style="font-weight: bold;font-size: 18px;">统计</span>：</div>
				<div style="margin-right: 30px;font-size: 16px;">
					资产总和 ({{ sumData.total }})
				</div>
				<div style="margin-right: 30px;font-size: 16px;">
					可用 ({{ sumData.inUseCnt }})
				</div>
				<div style="margin-right: 30px;font-size: 16px;">
					冻结 ({{ sumData.lockCnt }})
				</div>
				<div style="margin-right: 30px;font-size: 16px;">
					可挂买的DWQ数量 ({{ sumData.canSaleCnt }})
				</div>
			</div>
		</div>
		<el-table :data="propertyList.list" stripe style="width: 100%;" :header-cell-style="headClass"
			v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<!-- <el-table-column prop="id" label="序号" sortable align="center">
            </el-table-column> -->
			
			<el-table-column prop="username" label="账号" align="center" width="370">
				<template slot-scope="scope">
					<span> {{scope.row.userId+'~'+scope.row.username+'~'+scope.row.phone}}</span>
				</template> 
			</el-table-column>
			
			<el-table-column prop="introduce" label="资产名称" align="center">
			</el-table-column>
			<el-table-column prop="introduce" label="资产类别" align="center">
				<template slot-scope="scope">
					<span> {{scope.row.integralType==0?'积分':scope.row.integralType==1?'ERC20':scope.row.integralType==2?'币安链':'OKEX'}}</span>
				</template>
				
			</el-table-column>
			<el-table-column prop="withdrawalAddress" label="钱包地址" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button type="small" @click="lookaddress(scope.row)">查看</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="total" label="资产总和" align="center">
			</el-table-column>
			<el-table-column prop="inUseCnt" label="可用" align="center">
            <template slot-scope="scope">
				<span> {{scope.row.inUseCnt}}</span>
			</template>
			</el-table-column>
			<el-table-column prop="lockCnt" label="冻结" align="center">
				<template slot-scope="scope">
					<span> {{scope.row.lockCnt}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="canSaleCnt" label="可挂买的DWQ数量" align="center">
            </el-table-column>
			
			<!-- <el-table-column prop="createDate" label="创建时间" align="center" :show-overflow-tooltip="true">
			</el-table-column> -->
			<!-- <el-table-column prop="createDate"  label="操作"  fixed="right" align="center"  width="150">
				<template slot-scope="scope">
					<el-button v-if="isZR" type="text" size="small" @click="open(scope.row)">资产转换</el-button>
					<span v-else>不可操作</span>
				</template>
			</el-table-column> -->
		</el-table>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<el-pagination style="margin: 20px;" background :current-page="propertyList.pageNum"
				@current-change="pageChange" @size-change="handleSizeChange"
				layout="total, sizes, prev, pager, next, jumper" :total="propertyList.total">
			</el-pagination>
		</div>
		<el-dialog 
			title="资产转换"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			width="40%">
			<el-form :model="data">
				<el-form-item label="用户:">
					<span>{{ data.userId }}~{{ data.username }}</span>
				</el-form-item>
				<div style="display: flex;">
					<el-form-item label="资产名称:" style="margin-right: 20px;">
						<span>{{ data.introduce }}</span>
					</el-form-item>
				</div>
				<div style="display: flex;">
					<el-form-item label="资产总和:" style="margin-right: 20px;">
						<span>{{ data.total }}</span>
					</el-form-item>
					<el-form-item :label="data.integralId != 2 ?'可用:' : '动静包:'" style="margin-right: 20px;">
						<span>{{ data.inUseCnt }}</span>
					</el-form-item>
					<el-form-item :label="data.integralId != 2  ?'冻结:':'加速包:'" style="margin-right: 20px;">
						<span>{{ data.lockCnt }}</span>
					</el-form-item>
				</div>
				<div>
					<el-form-item label="转入资产:" style="margin-right: 20px;">
						<el-input style="width: 200px;" v-model="data.into" :placeholder="`最多转入${radio == 2 ? (data.inUseCnt ) : data.lockCnt}` "></el-input>
						<el-button style="margin-left: 20px;" type="primary" round @click="allInto(radio == 2 ? (data.inUseCnt ) : data.lockCnt)">全部转入</el-button>
					</el-form-item>
				</div>
				<div>
					<el-form-item label="操作类型:" style="display: flex;align-items: center;">
						<el-radio-group v-model="radio" v-if="data.integralId != 2 ">
							<el-radio :label="1">解冻</el-radio>
							<el-radio :label="2">冻结</el-radio>
						</el-radio-group>
						<el-radio-group v-model="radio" v-else>
							<el-radio :label="1">转动静包</el-radio>
							<el-radio :label="2">转加速包</el-radio>
						</el-radio-group>
					</el-form-item>
				</div>
				<div>
					<el-form-item label="上传附件">
						<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
							:on-remove="handleRemove" :file-list="fileList" :show-file-list="true" :limit="5"
							:on-success="onSuccess1">
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
				</div>
				<div>
					<el-form-item label="备注">
						<el-input v-model="data.remark" placeholder="请输入备注" style="width: 250px;"></el-input>
					</el-form-item>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="sure">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 审核 -->
		<el-dialog 
			title="复核记录"
			:visible.sync="downloadExamine"
			:close-on-click-modal="false"
			width="80%">
			<el-form :inline="true"  :model="searchInfoData">
				<el-form-item label="UID">
					<el-input v-model="searchInfoData.userId" placeholder="请输入UID"></el-input>
				</el-form-item>
				<el-form-item label="账号名称">
					<el-input v-model="searchInfoData.username" placeholder="请输入账号名称"></el-input>
				</el-form-item>
				<el-form-item label="复核状态">
					<el-select v-model="searchInfoData.status" placeholder="请选择" clear>
							<el-option key="1" label="待复核" :value="1">待复核</el-option>
							<el-option key="2" label="已通过" :value="2">已通过</el-option>
							<el-option key="3" label="已驳回" :value="3">已驳回</el-option>
						</el-select>
				</el-form-item>
				<el-button type="primary" @click="searchFH">查询</el-button>
				<el-button @click="emptyFH">清空</el-button>
			</el-form>
			<el-table :data="dataInfo" stripe style="width: 100%;" :header-cell-style="headClass">
				<el-table-column prop="userId" label="用户ID" sortable align="center">
				</el-table-column>
				<el-table-column prop="username" label="账号" align="center">
				</el-table-column>
				<el-table-column prop="integralName" label="资产名称" align="center">
				</el-table-column>
				<el-table-column prop="amount" label="转入资产" align="center">
				</el-table-column>
				<el-table-column prop="type" label="操作类型" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.type == 1 && scope.row.integralId != 2">解冻</span>
						<span v-if="scope.row.type == 2 && scope.row.integralId != 2">冻结</span>
						<span v-if="scope.row.type == 1 && scope.row.integralId == 2">转动静包</span>
						<span v-if="scope.row.type == 2 && scope.row.integralId == 2">转加速包</span>
					</template>
				</el-table-column>
				<el-table-column prop="status" label="复核状态" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 1">待复核</span>
						<span v-if="scope.row.status == 2">已通过</span>
						<span v-if="scope.row.status == 3">已驳回</span>
					</template>
				</el-table-column>
				<el-table-column prop="checkBy" label="操作人" align="center">
				</el-table-column>
				<el-table-column prop="reviewBy" label="复核人" align="center">
				</el-table-column>
				<el-table-column prop="rechargeMemo" :show-overflow-tooltip="true" label="备注" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.rechargeMemo">{{ scope.row.rechargeMemo }}</span>
						<span v-else>无</span>
					</template>
				</el-table-column>
				<el-table-column prop="reasonsforrefusal" :show-overflow-tooltip="true" label="驳回原因" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.reasonsforrefusal">{{ scope.row.reasonsforrefusal }}</span>
						<span v-else>无</span>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" :show-overflow-tooltip="true" align="center">
				</el-table-column>
				<el-table-column prop="createDate"  label="操作"  fixed="right" align="center"  width="150">
					<template slot-scope="scope">
						<el-button type="text" v-if="scope.row.status == 1" size="small" @click="pass(scope.row.id,scope.row.integralId)">通过</el-button>
						<el-button type="text" v-if="scope.row.status == 1" size="small" @click="out(scope.row)">驳回</el-button>
						<span v-else>不可操作</span>
					</template>
				</el-table-column>
			</el-table>
			<div style="display: flex;align-items: center;justify-content: space-between;">
				<el-pagination style="margin: 20px;" background :current-page="dataInfoPageNum"
					@current-change="pageChange1" @size-change="handleSizeChange1" :page-sizes="[6, 12, 18, 24]"
					layout="total, sizes, prev, pager, next, jumper" :total="dataInfoTotal">
				</el-pagination>
			</div>
		</el-dialog>
		<el-dialog 
			title="驳回"
			:visible.sync="downloadBH"
			:close-on-click-modal="false"
			width="40%">
			<div style="display: flex;align-items: center;">
				<span>驳回原因：</span>
				<el-input v-model="bhText" style="width: 300px;"></el-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="downloadBH = false">取 消</el-button>
				<el-button type="primary" @click="bhSure">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog
			title="钱包地址"
			:visible.sync="addressflag"
			:close-on-click-modal="false"
			width="40%">
			<div style="display: flex;align-items: center;">
				<span>钱包地址：</span>
				<span v-if="addressText">
					<span>{{addressText}}</span>
					<span style="padding-left: 10px;text-decoration: underline;color: red;" @click="onCopy">一件复制</span>
				</span>
				<span>暂未设置</span>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="addressflag = false">关 闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFileServer
	} from "@/api/axios.js";
	import debounce from '@/api/debounce.js'
	var urls = uploadFileServer('property');
	export default {
		data() {
			return {
				addressflag:false,
				httpUrl: urls,
				addressText:'',
				homedata: {},
				bhText:'',
				downloadBH:false,
				loading: false,
				searchInfoData:{},
				propertyList: [], //资产列表
				dialogVisible: false,
				downloadExamine: false,
				integralList: [],
				integralId: "", //积分id
				appropriation: "",
				radio:1,
				ids: '', //授权用户id
				userData: [{}], //用户角色列表
				userDataList: [], //用户角色列表选中的
				formLabelWidth: "200px",
				dialogImageUrl:'',
				value1:true,
				dataInfoPageNum: '',
				dataInfoTotal: '',
				goodsImages: [],
				limtlist1:[],
				limtlist2:[],
				sumData:{},
				data:{},
				outData: {},
				dataInfo: [],
				fileList: [],
				isZR: false,
				isFH: false,
				page: {
					pageNum: 1,
					pageSize: 10
				},
				page1: {
					pageNum: 1,
					pageSize: 6
				},
				searchInfo: {
					integralId: ''
				},
				allData: {}
			};
		},
		filters: {
			intToFloatfour(val) {
				return (Math.floor(Number(val) * 10000) / 10000).toFixed(4)
			},
			cutZero(old) {
				//拷贝一份 返回去掉零的新串
				old = old + ""
				var newstr = old
				//循环变量 小数部分长度
				var i = 0
				var leng = old.length - old.indexOf(".") - 1
				//判断是否有效数
				if (old.indexOf(".") > -1) {
					//循环小数部分
					for (i = leng; i > 0; i--) {
						//如果newstr末尾有0
						if (newstr.lastIndexOf("0") > -1 && newstr.substr(newstr.length - 1, 1) == 0) {
							var k = newstr.lastIndexOf("0")
							//如果小数点后只有一个0 去掉小数点
							if (newstr.charAt(k - 1) == ".") {
								return newstr.substring(0, k - 1)
							} else {
								//否则 去掉一个0
								newstr = newstr.substring(0, k)
							}
						} else {
							//如果末尾没有0
							return newstr
						}
					}
				}
				return old
			}
		},
		methods: {
			 onCopy() {
			      var input = document.createElement("input"); // 创建input对象
			         input.value = this.addressText; // 设置复制内容
			         document.body.appendChild(input); // 添加临时实例
			         input.select(); // 选择实例内容
			         document.execCommand("Copy"); // 执行复制
			         document.body.removeChild(input); // 删除临时实例
			         this.$message.success('复制成功！');
			 },
			onSuccess1(response, file) {
				console.log(response)
				this.goodsImages.push(response.message)
				this.fileList.push({
					"url": response.message
				})
				console.log("asda", this.fileList)
			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.goodsImages.remove(file.response.message);
				}
				// this.goodsImages.remove(file.url);
				this.fileList = this.fileList.filter(item => item.uid !== file.uid)
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			getHomeDate() {
				this.$api.homeDate().then((res) => {
					if (res.state == 'success') {
						this.homedata = res.data
					}
				})
			},
			lookaddress(e){
				this.addressflag=true
				this.addressText=e.withdrawalAddress
			},
			downloadFile() {
				let data = {
					phone: this.searchInfo.phone ? this.searchInfo.phone : "",
					integralId: this.searchInfo.integralId ? this.searchInfo.integralId : "",
					userId: this.searchInfo.userId ? this.searchInfo.userId : "",
					username: this.searchInfo.username ? this.searchInfo.username : "",
				};
				//   console.log(data);
				this.$api.memberExcel(data).then((res) => {
					console.log(res.data);
					this.showloadFile(res.data);
				});
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "会员资产列表" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getpropertyList()
				this.getFindtotal(this.searchInfo)
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getpropertyList()
			},
			pageChange1(data) {
				this.page1.pageNum = data
				this.getDataInfo()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getpropertyList()
			},
			handleSizeChange1(val) {
				this.page1.pageSize = val
				this.getDataInfo()
			},
			getpropertyList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					phone: this.searchInfo.phone,
					integralId: this.searchInfo.integralId,
					userId: this.searchInfo.userId,
					withdrawalAddress:this.searchInfo.withdrawalAddress,
					username: this.searchInfo.username,
				}
				console.log(data)
				this.$api.getUserPropertyList(data).then((res) => { // 管理列表
					res=JSON.parse(this.$decrypt(res.data))
					console.log('资产列表---', res.data.data)
					if (res.state == 'success') {
						this.propertyList = res.data.data
					}
					this.loading = false
				})
				// this.$api.getStatisticsUserPropertyList(data).then((res) => { // 管理列表
				//     if (res.state == 'success') {
				//         this.allData = res.data
				//     }
				// })

			},
			open(e) {
				console.log(e)
				this.data = e
				this.dialogVisible = true
			},
			sure() {
				this.dialogVisible = false
				let arr = []
				this.fileList.map(item => {
					console.log(item.url)
					arr.push(item.url)
				})
				let data = {
					userId: this.data.userId,
					integralId: this.data.integralId,
					amount: this.data.into,
					certificateImg: arr.join(","),
					rechargeMemo: this.data.remark,
					type: this.radio,
				}
				console.log(data)
				this.$api.editRechargeBalance(data).then(res => {
					this.$message({
						message: res.message,
						type: res.state
					});
					this.getpropertyList()
				})
			},
			downloadExamineD() {
				
				if(this.isFH){
					this.searchInfoData = {}
					this.downloadExamine = true
					this.getDataInfo()
				}else {
					this.$message({
						message: '您暂时没有权限',
						type: 'warning'
					});
				}
			
			},
			getDataInfo(obj) {
				let data = {
					userId: this.searchInfoData.userId,
					username: this.searchInfoData.username,
					status: this.searchInfoData.status,
					pageNum: this.page1.pageNum,
					pageSize: this.page1.pageSize
				}
				this.$api.adminDsRecordList(data).then(res => {
					console.log(res)
					this.dataInfo = res.data.list
					this.dataInfoTotal = res.data.total
					this.dataInfoPageNum = res.data.pageNum
				})
			},
			allInto(e) {
				console.log(e)
				// this.data.into = e
				this.$set(this.data,'into',e)
			},
			pass(id,inID) {
				this.$confirm('此操作将通过此记录, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
					}).then(() => {
								this.$api.editRechargeBalanceFuHe({id:id,integralId:inID,status:2}).then(res => {
									console.log(res)
								this.$message({
						type: 'success',
						message: res.message
					});
					this.getDataInfo()
				})}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});          
				});
			},
			out(e) {
				this.outData = e
				this.bhText = ''
				this.downloadBH = true;
			},
			bhSure() {
				this.downloadBH = false;
				let data = {
					id : this.outData.id,
					status: 3,
					reasonsforrefusal: this.bhText,
					integralId:  this.outData.integralId
				}
				console.log(data)
				this.$api.editRechargeBalanceFuHe(data).then(res => {
						console.log(res)
					this.$message({
            type: 'success',
            message: res.message
          });
					this.getDataInfo()
				})
			},
			searchFH() {
				this.getDataInfo()
			},
			emptyFH() {
				this.searchInfoData = {}
			},
			getFindtotal(obj) {
				this.$api.getFindTotal(obj).then(res => {
					res=JSON.parse(this.$decrypt(res.data))
					console.log('统计--',res)
					this.sumData = res.data
				})
			},
			getUserInfo(arr,name) {
				this.$api.getUserInfo().then(res=>{
					res.data=JSON.parse(this.$decrypt(res.data)).data
					// console.log('------',res.data.id);
					this.ids=res.data.id
					// this.ids = 29
					if(name == 'zr'){
						// console.log(name)
						this.isZR = arr.some(item => {
							return item == this.ids
						})
						// console.log('管理员id',this.ids)
						// console.log('转入',this.isZR)
					}else {
						this.isFH = arr.some(item => {
							return item == this.ids
						})
						// console.log('管理员id',this.ids)
						// console.log('复核',this.isFH)
					}
				})
			},
		},
		created() {
			// this.getHomeDate()
			// this.getpropertyList();
			// this.$api.getIntegralList(this.$encrypt({})).then((res) => {
			// 	res=JSON.parse(this.$decrypt(res.data))
			// 	if (res.state == 'success') {
			// 		this.integralList = res.data
			// 	}
			// })
			this.$api.getIntegralListTwo().then((res) => {
				// res=JSON.parse(this.$decrypt(res.data))
				if (res.state == 'success') {
					this.integralList = res.data
				}
			})
			// this.$api.getRecordTypeList(this.$encrypt()).then((res) => {
			// 	res=JSON.parse(this.$decrypt(res.data))
			// 	// console.log('数据---',res )
			// 	if (res.state == 'success') {
			// 		this.integralList = res.data
			// 	}
			// })
			// 可复核管理员ID
			this.$api.byKey({key:'SYS_REVIEW_RECHARGE'}).then(res=>{
					res=JSON.parse(this.$decrypt(res.data))
					if(res.state == 'success'){
						this.limtlist2 = (res.data.settingValue.split(','))
						// console.log(this.limtlist2)
						this.getUserInfo(this.limtlist2,'sh')
					}
			})
			// this.$api.byKey({key:'SYS_Conversion'}).then(res=>{
			// 		res = JSON.parse(this.$decrypt(res.data))
			// 		if(res.state == 'success'){
			// 			console.log('未知---',res.data)
			// 			this.limtlist1 = (res.data.settingValue.split(','))
			// 			this.getUserInfo(this.limtlist1,'zr')
			// 		}
			// })
			// this.getFindtotal(this.searchInfo)

		}
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
		margin-left: 30px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}
</style>
